import { personaSchema } from '@platform/schema/content';

import type { Persona } from '@platform/schema/content';

/**
 * What a reviewer reads instead of the enum member — spec 015, 016 §2.
 *
 * A `Record<Persona, string>` and not a lookup with a fallback: a seventh persona is then
 * a compile error here rather than a blank cell in the library, which is the reasoning
 * `sceneKeyColumn` gives in `publish-rules.ts`.
 *
 * The first name 015 illustrates each archetype with is deliberately absent. Its own
 * opening says not to build for the example role, and a screen labelled "Maya" is where
 * that starts.
 */
export const PERSONA_NAME: Record<Persona, string> = {
  CAREER_STARTER: 'Career starter',
  RISING_MANAGER: 'Rising manager',
  FUTURE_EXECUTIVE: 'Future executive',
  FOUNDER_OWNER: 'Founder or owner',
  EXPERIENCED_IC: 'Experienced specialist',
  CAREER_SWITCHER: 'Career switcher',
};

/** The six, in the order 015 presents them, for a picker. */
export const PERSONAS = personaSchema.options;

/**
 * Widened for the reason `edits.ts` widens `sceneRole`: the SDK renders an enum as a plain
 * string, so narrowing here would need a cast at every call site. The map above stays
 * keyed on `Persona`, which is where a seventh archetype has to be a compile error.
 */
const READ: Record<string, string> = PERSONA_NAME;

const AT: Record<string, number> = Object.fromEntries(
  PERSONAS.map((persona, at) => [persona, at]),
);

export function personaName(persona: string): string {
  return READ[persona] ?? persona;
}

/** Where a persona sits in 015's order, which is the only ordering the console has. */
export const personaOrder = (persona: string): number =>
  AT[persona] ?? PERSONAS.length;
